import React, { createContext, useCallback, useState, useMemo } from 'react';

// One-shot signal: a surface outside the chat region (e.g. the MembersPanel
// quick-reply icon) can call `prefill(handle)` to drop "@handle " into the
// composer and focus it. The Composer reads the pending value on every
// render, applies it, and calls `consume()` to clear the slot — so the
// signal fires exactly once per prefill request.
//
// Lightweight on purpose: just a (pending, prefill, consume) trio. If we
// ever grow real mentions or reply-quote previews this provider is the
// place to add a richer payload (e.g. { handle, messageId, text }).

export const ComposerPrefillContext = createContext(null);

export function ComposerPrefillProvider({ children }) {
  const [pending, setPending] = useState(null);

  const prefill = useCallback((handle) => {
    if (!handle) return;
    setPending(String(handle));
  }, []);

  const consume = useCallback(() => {
    setPending(null);
  }, []);

  const value = useMemo(
    () => ({ pending, prefill, consume }),
    [pending, prefill, consume],
  );

  return (
    <ComposerPrefillContext.Provider value={value}>
      {children}
    </ComposerPrefillContext.Provider>
  );
}

export default ComposerPrefillProvider;
